import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  startColor?: string;
  endColor?: string;
  key?: string;
}

const Klub2Icon: NextPage<Props> = ({
  width = "32",
  height = "32",
  startColor = "#FFFFFF",
  endColor = "#FFFFFF",
  key = "1",
}) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.4536 16C25.4025 15.1591 25.9979 13.9483 25.9979 12.6033C25.9979 10.062 23.8687 8 21.2409 8C20.0858 8 19.0255 8.39876 18.2007 9.06198L18.1965 9.06612C18.1628 9.09298 17.0499 10.0661 16 10.9855C14.9501 10.0661 13.8372 9.09298 13.8035 9.06612L13.7993 9.06198C12.9745 8.39876 11.9163 8 10.7591 8C8.13129 8 6 10.062 6 12.6054C6 13.9483 6.59752 15.1591 7.54639 16C6.59752 16.843 6 18.0517 6 19.3967C6 21.9401 8.13129 24 10.7591 24C11.9142 24 12.9745 23.6012 13.7993 22.938L13.8035 22.9339C13.8372 22.907 14.9501 21.9339 16 21.0145C17.0499 21.9339 18.1628 22.907 18.1965 22.9339L18.2007 22.938C19.0255 23.6012 20.0837 24 21.2409 24C23.8687 24 26 21.938 26 19.3967C26 18.0517 25.4046 16.843 24.4557 16H24.4536ZM10.7591 10.4194C11.4366 10.4194 11.9226 10.686 12.215 10.9153C12.3812 11.0599 13.1997 11.7748 14.1485 12.6054C13.2018 13.4339 12.3812 14.1508 12.215 14.2955C11.9205 14.5269 11.4345 14.7913 10.7591 14.7913C9.49253 14.7913 8.46371 13.8099 8.46371 12.6054C8.46371 11.4008 9.49464 10.4194 10.7591 10.4194ZM12.2171 21.0868C11.9226 21.3182 11.4366 21.5826 10.7612 21.5826C9.49463 21.5826 8.46581 20.6012 8.46581 19.3967C8.46581 18.1921 9.49674 17.2107 10.7612 17.2107C11.4366 17.2107 11.9226 17.4773 12.2171 17.7066C12.3833 17.8512 13.2018 18.5661 14.1506 19.3967C13.2039 20.2252 12.3833 20.9421 12.2171 21.0868ZM13.9697 16C14.3211 15.6942 15.1795 14.9421 16.0021 14.2231C16.9531 13.3905 17.8515 12.6033 17.8515 12.6033C18.8003 11.7748 19.6188 11.0579 19.785 10.9132C20.0795 10.6818 20.5655 10.4174 21.2409 10.4174C22.5075 10.4174 23.5363 11.3988 23.5363 12.6033C23.5363 13.8079 22.5054 14.7893 21.2409 14.7893C20.0858 14.7893 19.0255 15.188 18.2007 15.8512L18.1965 15.8554C18.1902 15.8616 18.0324 15.9979 18.0324 15.9979C18.0324 15.9979 16.8226 17.0558 16 17.7748C15.1795 17.0558 14.3211 16.3058 13.9676 15.9979L13.9697 16ZM21.2409 21.5826C20.5655 21.5826 20.0795 21.3161 19.785 21.0868C19.6188 20.9421 18.8003 20.2273 17.8515 19.3967C18.7982 18.5682 19.6188 17.8512 19.785 17.7066C20.0795 17.4752 20.5655 17.2107 21.2409 17.2107C22.5075 17.2107 23.5363 18.1921 23.5363 19.3967C23.5363 20.6012 22.5054 21.5826 21.2409 21.5826Z"
        fill={`url(#${key})`}
      />
      <defs>
        <linearGradient
          id={key}
          x1="6"
          y1="17.4783"
          x2="26"
          y2="17.4783"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Klub2Icon;
